(() => {
  'use strict';

  if (window.CLXCollectionSearchBootstrapV292) return;
  window.CLXCollectionSearchBootstrapV292 = true;

  const cleanBlankFilters = (value) => {
    if (value === null || value === undefined || value === '') return value;

    const input = String(value);
    let url;

    try {
      url = new URL(input, window.location.href);
    } catch (_) {
      return value;
    }

    let changed = false;
    const keys = [...new Set(url.searchParams.keys())];

    keys.forEach((key) => {
      if (!key.startsWith('filter.')) return;

      const values = url.searchParams.getAll(key);
      const nonBlank = values.filter((item) => String(item ?? '').trim() !== '');

      if (nonBlank.length === values.length) return;

      url.searchParams.delete(key);
      nonBlank.forEach((item) => url.searchParams.append(key, item));
      changed = true;
    });

    if (!changed) return value;

    if (/^[a-z][a-z0-9+.-]*:/i.test(input)) return url.toString();
    return `${url.pathname}${url.search}${url.hash}`;
  };

  const nativePushState = window.history.pushState.bind(window.history);
  const nativeReplaceState = window.history.replaceState.bind(window.history);

  window.history.pushState = (state, title, url) =>
    nativePushState(state, title, cleanBlankFilters(url));

  window.history.replaceState = (state, title, url) =>
    nativeReplaceState(state, title, cleanBlankFilters(url));

  const normalizeCurrentUrl = () => {
    const cleaned = cleanBlankFilters(window.location.href);
    if (cleaned !== window.location.href) nativeReplaceState(window.history.state, '', cleaned);
  };

  normalizeCurrentUrl();
  window.addEventListener('popstate', normalizeCurrentUrl);

  const currentScriptUrl =
    document.currentScript?.src ||
    [...document.scripts].find((script) => /clx-collection-search\.js(?:\?|$)/.test(script.src))?.src;

  if (!currentScriptUrl) {
    console.error('[CLX collection search bootstrap v2.9.2] Core asset URL not found.');
    return;
  }

  const coreUrl = new URL(currentScriptUrl, window.location.href);
  coreUrl.pathname = coreUrl.pathname.replace(
    /clx-collection-search\.js$/,
    'clx-collection-search-core-v29.js'
  );

  // The core asset is loaded dynamically, so Shopify cannot inject the core file's
  // own asset_url cache key here. Bust the CDN/browser cache whenever the core build changes.
  coreUrl.searchParams.set('clx_core', '20260927-set-search-v1');

  const coreScript = document.createElement('script');
  coreScript.src = coreUrl.toString();
  coreScript.dataset.clxCollectionSearchCore = 'v29';
  coreScript.onerror = () =>
    console.error('[CLX collection search bootstrap v2.9.2] Core asset failed to load.');
  document.head.appendChild(coreScript);
})();
